module.exports = __webpack_public_path__ + "img/product-07.67e86758.jpg";